'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Smile = require('./Smile');

var _Smile2 = _interopRequireDefault(_Smile);

var _Check = require('./Check');

var _Check2 = _interopRequireDefault(_Check);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GenericContent(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 64 : _ref$size,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? _react2.default.createElement(_Check2.default, null) : _ref$icon,
      _ref$center = _ref.center,
      center = _ref$center === undefined ? _react2.default.createElement(_Smile2.default, null) : _ref$center,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#4978BB' : _ref$color;

  return _react2.default.createElement(
    'div',
    { style: { width: size, height: size + 8 }, className: 'jsx-3084461012' + ' ' + 'holder'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-3084461012' + ' ' + 'icon'
      },
      icon
    ),
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-3084461012' + ' ' + 'inside'
      },
      center
    ),
    _react2.default.createElement(
      'svg',
      {
        width: size,
        height: size + 8,
        viewBox: '0 0 40 48',
        version: '1.1',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
        className: 'jsx-3084461012'
      },
      _react2.default.createElement(
        'defs',
        {
          className: 'jsx-3084461012'
        },
        _react2.default.createElement(
          'linearGradient',
          { x1: '100%', y1: '100%', x2: '0%', y2: '100%', className: 'jsx-3084461012'
          },
          _react2.default.createElement('stop', { stopColor: '#FFF', offset: '0%', className: 'jsx-3084461012'
          }),
          _react2.default.createElement('stop', { stopColor: '#FFF', stopOpacity: 0, offset: '100%', className: 'jsx-3084461012'
          })
        ),
        _react2.default.createElement(
          'linearGradient',
          { x1: '50%', y1: '0%', x2: '50%', y2: '100%', className: 'jsx-3084461012'
          },
          _react2.default.createElement('stop', { stopColor: '#FFF', offset: '0%', className: 'jsx-3084461012'
          }),
          _react2.default.createElement('stop', { stopColor: '#FFF', stopOpacity: 0, offset: '100%', className: 'jsx-3084461012'
          })
        )
      ),
      _react2.default.createElement(
        'g',
        {
          transform: 'translate(-8.000000, -4.000000)',
          stroke: 'none',
          strokeWidth: 1,
          fill: 'none',
          fillRule: 'evenodd',
          className: 'jsx-3084461012'
        },
        _react2.default.createElement('rect', { fill: color, x: 8, y: 4, width: 40, height: 48, rx: 6, className: 'jsx-3084461012'
        }),
        _react2.default.createElement('path', {
          d: 'M45.185 10a.797.797 0 0 1-.808-.784 1.446 1.446 0 0 0-.393-1.174 1.543 1.543 0 0 0-1.176-.473.797.797 0 0 1-.808-.784c0-.433.362-.784.808-.784a3.162 3.162 0 0 1 2.324.926c.606.612.918 1.442.861 2.289a.772.772 0 0 1-.236.554.821.821 0 0 1-.572.23z',
          fill: '#FFF',
          fillRule: 'nonzero',
          opacity: '0.800000012',
          className: 'jsx-3084461012'
        }),
        _react2.default.createElement('path', {
          d: 'M39.365 7.6h-13.73c-.35 0-.635-.358-.635-.8 0-.442.284-.8.635-.8h13.73c.35 0 .635.358.635.8 0 .442-.284.8-.635.8z',
          fill: 'url(#a)',
          fillRule: 'nonzero',
          opacity: '0.5',
          className: 'jsx-3084461012'
        }),
        _react2.default.createElement('path', {
          d: 'M44.8 24c-.442 0-.8-.318-.8-.71V12.71c0-.392.358-.71.8-.71.442 0 .8.318.8.71v10.58c0 .392-.358.71-.8.71z',
          fill: 'url(#b)',
          fillRule: 'nonzero',
          opacity: '0.5',
          className: 'jsx-3084461012'
        })
      )
    ),
    _react2.default.createElement(
      _style2.default,
      {
        id: '3084461012'
      },
      ['.green.jsx-3084461012{fill:#00b083;}', '.purple.jsx-3084461012{fill:#7878cb;}', '.gray.jsx-3084461012{fill:#767c7c;}', '.holder.jsx-3084461012{position:relative;display:inline-block;}', '.icon.jsx-3084461012{position:absolute;bottom:-10%;right:-5%;}', '.inside.jsx-3084461012{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);}']
    )
  );
}

GenericContent.propTypes = {
  size: _propTypes2.default.number,
  icon: _propTypes2.default.node,
  center: _propTypes2.default.node,
  color: _propTypes2.default.string
};

exports.default = GenericContent;